module.exports = __webpack_public_path__ + "static/img/boothStep1.1a329f5e.jpg";